import $ from 'cash-dom';
import install_teaser_tracker from './teaser_track';
import { createActionEvent } from './createActionEvent';
import { DataLayer, Tracking } from '@hmg/consent-and-tracking';
import { WT } from './wt';
import { SiteLevel2Enum } from '@hmg/data-layer-api-specification-node';

import initCMP from './cmp';

let trackerDL;
export default function ({ appIdentifier, siteLevel2 } = {}) {
  // catch all action-track stuff
  // all elements with data-action = track
  console.log(`Init tracking with `, { appIdentifier, siteLevel2 });

  const dataLayer = DataLayer.create();
  /**
   * Cmp
   */
  const cmp = initCMP();

  function installCMPDialogListener(cmp) {
    document.addEventListener(
      'click',
      function (event) {
        // If the clicked element doesn't have the right selector, bail
        try {
          if (event.target) {
            let element = event.target.closest('a');
            if (
              element &&
              ((element.classList && element.classList.contains('js-cmp-ds')) ||
                (element.hash && element.hash === '#js-cmp-ds'))
            ) {
              // Don't follow the link
              event.preventDefault();
              window._sp_.gdpr.loadPrivacyManagerModal(window._sp_.config.privacyManagerId);
              // cmp.openModal();
            }
          }
        } catch (e) {
          //
          console.error(e);
        }
      },
      false
    );
  }

  function trackingFactory(cmp) {
    const AT_INTERNET_VENDOR_ID = '5ebccbdd1c88a339cd3227ea';
    // siteLevel2enum should be wiwo/hb!
    const app = { appIdentifier, siteLevel2 };
    const user = {};

    return new Tracking(AT_INTERNET_VENDOR_ID, cmp, app, user);
  }

  function getUrlWithPath(url) {
    try {
      const { origin, pathname } = new URL(url);

      return `${origin}${pathname}`;
    } catch {
      return '';
    }
  }

  cmp.init(dataLayer).then(() => {
    // cmp init
    console.log('CMP INIT DONE');

    trackerDL = (function () {
      const wt = new WT(cmp);
      // create tracking
      const tracking = trackingFactory(cmp);

      return {
        cmp,
        dataLayer,
        tracking,
        push(data) {
          const { event, ...rest } = data;
          // just push data?
          switch (event) {
            case 'action':
              {
                // linkId, customClickParameter
                const { id: linkId, ...p } = rest;
                wt.action({ linkId, customClickParameter: p });
              }
              break;
            case 'pageView':
              {
                wt.trackPage(rest);
              }
              break;
          }
        },
      };
    })();

    let tracking_page_name, tracking_page_variant;
    if (window.post_meta) {
      tracking_page_name = window.post_meta.tracking_page_name;
      tracking_page_variant = window.post_meta.tracking_page_variant;
    } else {
      tracking_page_name = $('meta[name~=tracking_page_name]').attr('content');
      tracking_page_variant = $('meta[name~=tracking_page_variant]').attr('content');
    }

    const prefix = siteLevel2 === SiteLevel2Enum.hb_web ? 'hb' : 'ww';

    trackerDL.push({
      event: 'pageView',
      customParam1: 'offerpage',
      customParam2: tracking_page_variant,
      contentId: `${prefix}.${tracking_page_name}.offerpage`,

    });
    // contruct referrer
    const referrerUrl = getUrlWithPath(document.referrer);
    trackerDL.tracking.trackPage({
      page: `${tracking_page_name} | offerpage`,
      pageNum: '1_1',
      pageType: 'offerpage',
      pageTypeDetail: tracking_page_variant,
      referrerUrl,
    });
    //
  });

  // page on load
  $(() => {
    // install click listener
    installCMPDialogListener(cmp);
    $('body').on('click', '[data-action~=track]', (e) => {
      // console.log('Click on TRACK element', e.target, e.currentTarget);
      let ds = e.target.dataset;
      if (e.target !== e.currentTarget) {
        if (e.currentTarget.dataset.action === 'track') {
          ds = e.currentTarget.dataset;
        }
      }
      // get dataset

      if (ds.actionParams) {
        let params = ds.actionParams;

        // try to parse
        try {
          params = JSON.parse(params);
        } catch (e) {
          console.warn('[tracking] click params is not JSON, use as is: ', params);
        }
        // we have params, let's track?
        trackerDL.push(createActionEvent(params));
      }
    });
    install_teaser_tracker(trackerDL);

    // get the data for page view
  });

  window.__aboshop__tracker = trackerDL;
}

export { trackerDL as tracker };
